<template>
<div class="right-body" id="right-preview">
    <div class="right-preview-middle">
        <div class="preview-title">
            <div class="preview-posiiton">
                <div class="file-title-name">
                    <div class="icon-util come-back come-back-position" @click="goBackPage()"></div>
                    <div class="text-name" :title="fileInfo.name">{{fileInfo.name}}</div>
                </div>
                <div class="text-modified">{{$t('language.cloudExploer.modified')}} {{fileInfo.modifiedTime|transferTime}}</div>
            </div>
            <div class="preview-icon">
                <div :title="$t('language.common.copyTo')" class="icon-util big-copy-to preview-icon-position" @click="copyToShow()"></div>
                <div :title="$t('language.common.download')" class="icon-util big-download preview-icon-position" @click="downLoad()"></div>
                <!-- <div title="Share" class="icon-util big-share preview-icon-position" @click="shareOpen()"></div> -->
                <div :title="$t('language.common.delete')" class="icon-util big-delete preview-icon-position" v-if="limits.write" @click="deleteFile()"></div>
            </div>
        </div>
        <div class="open-with" @click="onlineShow=!onlineShow" v-clickoutside="onlineClose" v-if='false'>
            <div class="open-width-txt">{{$t('language.cloudExploer.openWith')}}</div>
            <div class="icon-util  open-width-position" :class="onlineShow?'drop-down-up':'drop-down'"></div>
            <div class="office-online" v-if="onlineShow" @click.stop="officeOnlineOpen()">
                <div class="icon-util office-online-icon office-online-icon-position"></div>
                <div class="office-online-txt">{{$t('language.cloudExploer.officeOnline')}}</div>
            </div>
        </div>
    </div>
    <div class="right-preview-body" @wheel="rollImg()">
        <div class="preview-loading" v-if="loadFlag">{{$t('language.cloudExploer.loading')}}</div>
        <iframe v-if='googleDriveArr.includes(fileType)' :class="fileType=='txt'?'iframe-txt-width':''" ref="googleDriveView" height='96%' seamless='seamless' frameborder='no' class='iframe-position' scrolling='auto' :src="fileUrl">
        </iframe>
        <iframe v-if='officeArr.includes(fileType)' height='96%' width='98%' seamless='seamless' frameborder='no' class='iframe-position' scrolling='auto' :src="fileUrl">
        </iframe>
        <img v-if='imgArr.includes(fileType)' ref="bigImage" style="transform:matrix(1, 0, 0, 1, 0, 0)" :src="fileUrl" />
        <div class="img-zoom" v-if='imgArr.includes(fileType)'>
            <div class="icon-util zoom-down preview-icon-posiiton" @click="zoomDown()"></div>
            <div class="icon-util zoom-recover preview-icon-posiiton" @click="zoomRecover()"></div>
            <div class="icon-util zoom-up preview-icon-posiiton" @click="zoomUp()"></div>
        </div>
        <div v-if="otherType" class="other-type">
            <div class="other-img"></div>
            <div>
                <span class="suffix-type">.{{fileType}}</span>
                <span class="not-review">{{$t('language.preview.fileNotReview')}}</span>
            </div>
            <div class="exe-info">
                <span :title="fileInfo.name">{{fileInfo.name|ellipsisNavi}} - {{fileInfo.size|formatByte}}</span>
            </div>
            <div>
                <button class="exe-button" v-if="toOfficialSiteshow()" @click="goOfficialSite()">{{$t('language.preview.goOringinalSite')}}</button>
            </div>
        </div>
    </div>
    <shareDialog ref="shareDialog"></shareDialog>
    <copyToDialog ref="copyToDialog"></copyToDialog>
    <fileExistDialog ref="fileExistDialog"></fileExistDialog>
    <detailedProgrssDialog ref="detailedProgrss"></detailedProgrssDialog>
    <remindBindEmailDialog ref="remindBindEmailDialog"></remindBindEmailDialog>
</div>
</template>

<script>
import copyToDialog from "@/components/popup/cloud_exploer_popups/copy_to_popup";
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import shareDialog from "@/components/popup/cloud_exploer_popups/share_popup";
import fileExistDialog from '@/components/popup/cloud_exploer_popups/file_exist_popup.vue';
import detailedProgrssDialog from '@/components/popup/cloud_exploer_popups/detailed_progress_popup';
import remindBindEmailDialog from "@/components/popup/personal_center_popups/remind_bind_email_popup";
export default {
    data: function () {
        return {
            fileInfo: '',
            fileType: '',
            fileUrl: '',
            otherType: false,
            officeArr: ['xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx'], //调用office预览机制
            googleDriveArr: ['html', 'htm', 'shtml', 'shtm', 'xml', 'js', 'css', 'svg', 'pdf', 'txt'], //调用googleDrive预览机制
            imgArr: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'], //采用本地预览机制
            onlineShow: false,
            loadFlag: true,
            limits: {
                read: true,
                write: true,
            },//权限，默认读写权限
        }
    },
    components: {
        shareDialog,
        copyToDialog,
        fileExistDialog,
        detailedProgrssDialog,
        remindBindEmailDialog,
    },//初始化界面
    created() {
        if (this.$store.state.previewData) {
            this.fileInfo = this.$store.state.previewData[0];
        } else {
            let fileInfo = this.$store.getters.getPreviewData;
            this.$store.state.previewData = fileInfo;
            this.fileInfo = fileInfo[0];
        }
        //如果存在权限限制
        if(this.fileInfo.limits){
            this.limits = this.fileInfo.limits;
        }
        this.fileType = commonUtils.getSuffix(this.fileInfo.name).toLowerCase();
        if (this.googleDriveArr.includes(this.fileType)) {
            this.fileUrl = commonstate.googleDriveViewUrl + this.fileInfo.url;
            this.loadFlag = true;
        } else if (this.officeArr.includes(this.fileType)) {
            this.fileUrl = commonstate.officeAppUrl + encodeURI(this.fileInfo.url);
            this.loadFlag = true;
        } else if (this.imgArr.includes(this.fileType)) {
            this.fileUrl = this.fileInfo.url;
            this.loadFlag = false;
        } else {
            this.otherType = true;
        }
    },
    methods: {
        //判断 go to site按钮是否显示
        toOfficialSiteshow() {
            let flag = true;
            if (this.fileInfo.cloud) {
                $.each(this.fileInfo.cloud.methods, function (i, item) {
                    if (item.go_drive_site) {
                        flag = false;
                        return false;
                    }
                });
            }
            return flag;
        },//返回到上一页
        goBackPage() {
            if(this.fileInfo.driveType&&'Shares' == this.fileInfo.driveType){
                this.$router.push({
                    name: "shares",
                    query: {
                        fileId: this.fileInfo.id
                    }
                });
                this.$store.commit("setCatalogFileId", '');
            }else{
                history.go(-1);
                this.$store.commit("setCatalogFileId",this.fileInfo.id);
                this.$store.state.comeBackFileFlag=true;
            }
            
        },
        rollImg() {
            if (this.imgArr.includes(this.fileType)) {
                if (event.wheelDelta > 0) {
                    this.zoomUp();
                } else {
                    this.zoomDown();
                }
            }
        },
        zoomUp() {
            let transform = this.$refs.bigImage.style.transform;
            let x = parseFloat(transform.substring(7).split(',')[0]);
            x += 0.2;
            this.$refs.bigImage.style.transform = "matrix(" + x + ", 0, 0, " + x + ", 0, 0)";
        },
        zoomRecover() {
            this.$refs.bigImage.style.transform = "matrix(1, 0, 0, 1, 0, 0)";
        },
        zoomDown() {
            let transform = this.$refs.bigImage.style.transform;
            let x = parseFloat(transform.substring(7).split(',')[0]);
            if (x - 0.2 > 0) {
                x -= 0.2;
            }
            this.$refs.bigImage.style.transform = "matrix(" + x + ", 0, 0, " + x + ", 0, 0)";
        },
        officeOnlineOpen() {
            window.open(this.fileUrl);
        },
        onlineClose() {
            this.onlineShow = false;
        },
        deleteFile() {
            let that = this;
            let deleteData = {
                id: this.fileInfo.id,
                ud: commonstate.user.id,
                dd: this.fileInfo.driveId,
                pid: this.fileInfo.pid,
                dir: this.fileInfo.dir,
                tsh: true
            }
            this.Utils.doFilesRequest("delete", deleteData).then(res => {
                if (res.status == 200) {
                    let key = deleteData.pid + deleteData.dd;
                    let tableData = that.$store.state.cacheTableDatas[key];
                    if (tableData) {
                        tableData = tableData.tableData;
                        tableData.some((item, j) => {
                            if (item.id == deleteData.id) {
                                tableData.splice(j, 1);
                                return true;
                            }
                        });
                    }
                    that.$store.commit("setCacheTableDatas", {
                        id: deleteData.pid + deleteData.dd,
                        tableData: tableData
                    });
                    this.goBackPage();
                }else if(res.reason == "deletePermissionLimited"){
                    that.$toast({
                    text: that.$t('language.exception.deletePermissionLimited'),
                    type: 'fail',
                    idValue: "right-preview",
                    });
               } else if(res.reason == "notHaveDeletePermission"){
                    that.$toast({
                    text: that.$t('language.exception.notHaveDeletePermission'),
                    type: 'fail',
                    idValue: "right-preview",
                    });
               }
            });
        },
        shareOpen() {
            this.$refs.shareDialog.shareShow = true;
            this.rightMenuShow = false;
        },
        downLoad() {
            //判断是否是临时用户，然后提醒用户进行绑定邮箱
			let user = commonUtils.getUser();
			if (commonUtils.testUserIsTourist(user)) {
				this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
				return false;
			}
            let currentThis = this;
            let downloadData = {
                ud: commonstate.user.id,
                // dd: currentThis.$store.state.listData.dd,
                dd: currentThis.fileInfo.driveId,
                id: currentThis.fileInfo.id,
                n: currentThis.fileInfo.name
            };
            if(currentThis.fileInfo.webUrl){
                downloadData.webUrl = currentThis.fileInfo.webUrl;
            }
            currentThis.Utils.doFilesRequest("download.createSession", downloadData).then(result => {
                var $eleForm = commonUtils.createDownloadForm(result.download_id);
                $eleForm.submit();
            });
        },
        goOfficialSite() {
            let goData = {
                ud: commonUtils.getUser().id,
                dd: this.fileInfo.driveId,
                pid: this.fileInfo.pid,
                id: this.fileInfo.id
            }
            this.Utils.doFilesRequest("go_drive_site", goData).then(res => {
                if (res.status == 200) {
                    window.open(res.webSite);
                }
            });
        },
        copyToShow() {
            this.$refs.copyToDialog.copyToShow = true;
            this.$refs.copyToDialog.initData();
        },
    },
    filters:{
        ellipsisNavi(value) {
            let subStr;
            if (!value) return '';
            if (value.length > 37) {
                subStr = value.slice(0, 18) + '..' + value.slice(value.length - 18, value.length)
            } else {
                subStr = value;
            }
            return subStr;
        },
    }
};
</script>

<style>
.preview-icon-posiiton{
    float: left;
}
.preview-loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 0;
    width: 200px;
    /*no*/
    height: 20px;
    /*no*/
    font-size: 16px;
    /*no*/
    font-weight: bold;
    color: #3f467a;

}

.iframe-position {
    position: absolute;
    top: 2%;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 1px solid #cdddf5;
    /*no*/
    width: 98%;
    z-index: 100;
}

.right-preview-body img {
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 4%;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 1px solid #cdddf5;
    /*no*/
}

.iframe-txt-width {
    width: 80% !important;
}

#right-preview {
    background-color: #fff;
    position: relative;
}

.preview-icon-position {
    margin-left: 15px;
    /*no*/
}

.text-modified {
    font-size: 12px;
    /*no*/
    margin-top: 5px;
    /*no*/
    margin-left: 40px;
    /*no*/
    float: left;
}

.text-name {
    font-size: 18px;
    /*no*/
    float: left;
    margin-left: 30px;
    /*no*/
    width: 800Px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.right-preview-middle {
    height: 70px;
    /*no*/
    width: 100%;
    float: left;
    background-color: #f2f7fe;
    position: relative;
}

.right-preview-body {
    height: calc(100% - 80px);
    /*no*/
    width: 100%;
    background-color: #fff;
    float: left;
    position: relative;
    min-width: 1099px;
    /*no*/
    overflow: auto;
}

/*定义滑块，内阴影及圆角*/
.right-preview-body::-webkit-scrollbar {
    width: 9px;
    /*no*/
    height: 9px;
    /*no*/
    background-color: #fff;
}

.right-preview-body::-webkit-scrollbar-thumb {
    height: 1px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

.preview-title {
    width: 100%;
    height: 40px;
    /*no*/
    position: absolute;
    box-sizing: border-box;
    padding: 0% 2% 0% 2%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

.preview-posiiton {
    float: left;
    width: 850Px;
}

.come-back {
    width: 10px;
    /*no*/
    height: 25px;
    /*no*/
    background-position: -445px -204px;
    /*no*/
}

.preview-icon {
    width: 145px;
    /*no*/
    height: 25px;
    /*no*/
    float: right;
    margin-top: 10px;
    /*no*/
}

.preview-icon>.icon-util {
    cursor: pointer;
}

.file-title-name {
    float: left;
    width: 100%;
}

.come-back-position {
    float: left;
    position: relative;
    top: 2px;
    /*no*/
    cursor: pointer;
}

.img-zoom {
    width: 135px;
    /*no*/
    height: 35px;
    /*no*/
    position: fixed;
    left: 250px;
    /*no*/
    right: 0;
    margin: auto;
    bottom: 0;

}

.open-with {
    width: 110px;
    /*no*/
    background: #fff;
    border: 1px solid #8a96e3;
    /*no*/
    height: 30px;
    /*no*/
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    font-size: 13px;
    /*no*/
    color: #6f7886;
    line-height: 30px;
    /*no*/
    float: left;
}

.open-width-txt {
    width: 90px;
    /*no*/
    height: 100%;
    text-align: center;
}

.open-width-position {
    float: left;
    position: absolute;
    top: 0;
    right: 0;
}

.office-online {
    width: 180px;
    /*no*/
    height: 35px;
    /*no*/
    border: 1px solid #8a96e3;
    /*no*/
    position: absolute;
    background: #fff;
    z-index: 3;
    left: -1px;
    /*no*/
}

.office-online:hover {
    cursor: pointer;
    background: #EBF3FE;
}

.office-online-txt {
    width: 145px;
    /*no*/
    height: 100%;
    float: right;
    text-align: left;
    font-size: 12px;
    /*no*/
    line-height: 35px;
    /*no*/
}

.office-online-icon-position {
    position: relative;
    top: 7px;
    /*no*/
    left: 10px;
    /*no*/
}

.other-type {
    width: 347px;
    /*no*/
    height: 350px;
    /*no*/
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
}

.other-img {
    width: 347px;
    /*no*/
    height: 245px;
    /*no*/
    background-image: url("../../assets/images/workspace/un_preview.png");
    float: left;
}

.suffix-type {
    font-size: 16px;
    /*no*/
    font-weight: bold;
}

.not-review {
    font-size: 16px;
    /*no*/
    color: #6f7886;
    margin-left: 20px;
    /*no*/
}

.exe-info {
    color: #6f7886;
    margin-top: 20px;
    /*no*/
}

.exe-button {
    height: 50px;
    /*no*/
    margin-top: 30px;
    /*no*/
    font-size: 16px;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/preview.vue